import React from "react";

interface PageHeaderProps {
  title?: string;
  slug?: string;
}

const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  slug,
}) => {

  const displayTitle =
    title || slug?.replace(/-/g, " ");

  return (
    <div className="bg-gradient-to-r from-blue-900 via-indigo-900 to-blue-700 py-12 px-4 text-center shadow-lg">
      <h1
        className={`
          font-bold text-white uppercase tracking-wide break-words
          ${displayTitle && displayTitle.length > 35
            ? "text-2xl md:text-3xl"
            : "text-3xl md:text-4xl"}
        `}
      >
        {displayTitle}
      </h1>
    </div>
  );
};

export default PageHeader;